<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'News', route: '/backoffice/news' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">News</h1>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Elenco news</h2>
        </div>
        <a class="acc-btn acc-btn-primary" routerLink="/backoffice/news/add">+ Aggiungi news</a>
    </div>

    <p-table #dt [value]="notizie" [loading]="loading" responsiveLayout="stack" [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true"
        [globalFilterFields]="['titolo']" currentPageReportTemplate="{first} di {last} su {totalRecords} notizie"
        [rows]="10" [rowsPerPageOptions]="[5, 10, 20, 50, 100]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full">
                <div class="lg:w-3/4 w-full">
                    <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                        <p-inputicon styleClass="bi bi-search" />
                        <input type="text" pInputText (input)="onGlobalFilter(dt, $event)" placeholder="Cerca news…" [style]="{'width': '100%'}" />
                    </p-iconfield>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="titolo">Titolo <span class="inline-flex"><p-sortIcon field="titolo" /></span></th>
                <th pSortableColumn="data_creazione">Data <span class="inline-flex"><p-sortIcon field="data_creazione" /></span></th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-notizia>
            <tr>
                <td><span class="p-column-title">Titolo</span><span class="cell-nome">{{notizia.titolo}}</span></td>
                <td><span class="p-column-title">Data</span>{{notizia.data_creazione | date: 'dd/MM/yyyy'}}</td>
                <td class="text-center">
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/news/' + notizia.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteNews>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteNews()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteNews()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteNews($event, notizia)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessuna notizia trovata.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
